import { get,post,remove,put} from '../http/http';

export default {
  getStrategyList:(data)=>get('/hls/strategy',data), // 策略列表
  getStrategyDetail:(data)=>post('/hls/strategy/detail',data), // 策略详情
  getStrategyReport:(data)=>post('/hls/strategy/report',data), // 策略报表数据
  getAllPlatform:()=>get('/hls/strategy/platform/all'), // 获取所有平台
  getServiceList:(data)=>get('/hls/service-code',data), // 获取服务列表
  createService:(data)=>post('/hls/service-code',data), // 新增服务
  updateService:(data)=>put('/hls/service-code',data), // 修改服务
  removeService:(data)=>remove('/hls/service-code',data), // 删除服务
  getAllServiceType:()=>get('/hls/service-code/service-type/all'), // 获取所有服务类型
  getAllService:()=>get('/hls/service-code/open/query'), // 获取服务全量查询接口
  getAllServiceVendor:()=>get('/hls/service-code/vendor/all'), // 获取所有服务商
  updateQuato:(data)=>post('/hls/order/location/modifyQuato',data), // 修改额度
  recordLog:(data)=>get('/hls/record-log',data), // 调用日志列表
  mctypeList:(data)=>get('/hls/model',data), // 机型列表
  getAllMctype:(data)=>get('/hls/model/all',data), // 所有机型
  getDeviceList:(data)=>get('/hls/device',data), // 设备管理列表
  getDeviceDetail:(data)=>get('/hls/device/detail',data), // 设备管理详情
  getDeviceReport:(data)=>get('/hls/device/report',data), // 设备管理报表数据
  getUserList:(data)=>get('/hls/user',data), // 用户列表
  getUserDetail:(data)=>get('/hls/user/detail',data), // 用户详情
}
